export const DEFAULT_MAX_FILE_SIZE = 2097152; // 2MB

export const DEFAULT_VALID_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];
